<div class="card-body">
    <canvas height="100px" id="basic_horizontalBar_chart"></canvas>
</div>